import type { AgentV2Reference } from '@/agent-v2/store/schemas'

/**
 * The display-grouping identity of a reference's source document, derived from
 * its source metadata. The type prefix keeps ids from different corpora from
 * colliding.
 */
export function agentV2SourceKey(reference: AgentV2Reference): string {
  switch (reference.source_type) {
    case 'web':
      return `web:${reference.source.url}`
    case 'docket':
      // Mirrors reference_source_key (paxton_app/agent_v2/citations/sources.py): one docket's
      // case details, entries, and parties share a row; a search-results page has no docket,
      // so each page is its own row.
      return reference.source.docket_key === null ? `docket_search:${reference.citation_id}` : `docket:${reference.source.docket_key}`
    case 'caselaw':
    case 'lrr':
      return `${reference.source_type}:${reference.source.parent_id}`
    case 'administrative_decision':
      return `${reference.source_type}:${reference.source.stable_id}`
    case 'matter_file':
      return `${reference.source_type}:${reference.source.matter_file_id}`
    case 'living_asset':
      return `${reference.source_type}:${reference.source.asset_id}`
  }
}
